import { getOverdueTodos, getTodosDueToday } from 'redux/actions/todosActions';
import selectors from 'selectors/selectors';
import { store } from 'redux/lib/configureStore';

const containsNumbers = (str) => {
  return /\d/.test(str);
};

export const getTodosNotificationSlider = ({ serviceProviderId }) => {
  const state = store.getState();
  const filteredUserId = selectors.filteredUserId(state);
  if (serviceProviderId && containsNumbers(serviceProviderId)) {
    getOverdueTodos(serviceProviderId, filteredUserId, () => {}, 'GET_OVERDUE_TODOS_NOTIFICATIONS_SLIDER');
    return getTodosDueToday(serviceProviderId, filteredUserId, () => {}, 'GET_TODOS_DUE_TODAY_NOTIFICATIONS_SLIDER');
  }
};
